var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6094_1559",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6094_1559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 11.2501C13.6918 11.2501 13.9904 11.132 14.2265 10.8959C14.4627 10.6598 14.5807 10.3612 14.5807 10.0001C14.5807 9.63895 14.4627 9.34034 14.2265 9.10423C13.9904 8.86812 13.6918 8.75006 13.3307 8.75006C12.9696 8.75006 12.671 8.86812 12.4349 9.10423C12.1988 9.34034 12.0807 9.63895 12.0807 10.0001C12.0807 10.3612 12.1988 10.6598 12.4349 10.8959C12.671 11.132 12.9696 11.2501 13.3307 11.2501ZM11.0871 13.75C10.6662 13.75 10.3099 13.6042 10.0182 13.3125C9.72656 13.0209 9.58073 12.6646 9.58073 12.2436V7.7565C9.58073 7.33555 9.72656 6.97925 10.0182 6.68758C10.3099 6.39592 10.6662 6.25008 11.0871 6.25008H16.4076C16.8285 6.25008 17.1849 6.39592 17.4765 6.68758C17.7682 6.97925 17.914 7.33555 17.914 7.7565V12.2436C17.914 12.6646 17.7682 13.0209 17.4765 13.3125C17.1849 13.6042 16.8285 13.75 16.4076 13.75H11.0871ZM4.42048 17.0834C3.99953 17.0834 3.64323 16.9375 3.35156 16.6459C3.0599 16.3542 2.91406 15.9979 2.91406 15.577V4.42317C2.91406 4.00222 3.0599 3.64591 3.35156 3.35425C3.64323 3.06258 3.99953 2.91675 4.42048 2.91675H15.5743C15.9952 2.91675 16.3515 3.06258 16.6432 3.35425C16.9349 3.64591 17.0807 4.00222 17.0807 4.42317V5.00012H11.0871C10.2613 5.00012 9.59544 5.25305 9.08956 5.75892C8.5837 6.26479 8.33077 6.93065 8.33077 7.7565V12.2436C8.33077 13.0695 8.5837 13.7353 9.08956 14.2412C9.59544 14.7471 10.2613 15 11.0871 15H17.0807V15.577C17.0807 15.9979 16.9349 16.3542 16.6432 16.6459C16.3515 16.9375 15.9952 17.0834 15.5743 17.0834H4.42048Z",
    fill: "#9B9B9B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.4bf3f959a28cd3f6202d21fffd983331.svg";
export { ForwardRef as ReactComponent };